<script>
import Base from '@/views/succezz/components/common-addon.vue';
export default {
  name: "Zoom Events",
  extends: Base,
}
</script>
